import { createAsyncThunk } from "@reduxjs/toolkit";
import subscriptionService from "../../../api/services/subscription";

export const choosePlan = createAsyncThunk(
  "subscription/choose-plan",
  async (requestData) => {
    return await subscriptionService.choosePlan(requestData);
  },
);

export const fetchSubscriptions = createAsyncThunk(
  "subscription/fetch-subscriptions",
  async (requestData) => {
    return await subscriptionService.fetchSubscriptions(requestData);
  },
);

export const getSubscriptionsCreditsHistory = createAsyncThunk(
  "subscription/get-subscriptions-credits-history",
  async (page) => {
    return await subscriptionService.getSubscriptionsCreditsHistory(page);
  },
);

export const rechargeCredits = createAsyncThunk(
  "subscription/recharge-credits",
  async ({ paymentMethod, planId }) => {
    return await subscriptionService.rechargeCredits(planId, paymentMethod);
  },
);
